import React, { useState } from "react"
import { navigate } from "gatsby"
import { FormikWizard } from "formik-wizard"
import { useToasts } from "react-toast-notifications"
import { PaystackButton } from "react-paystack"
import { sendNotification, notifyUser } from "../../Helpers"

import Nav from "../../nav"
import steps from "./steps"
import FormWrapper from "./FormWrapper"
import Summary from "./views/Summary"

const onClose = () => {
  console.log("closed")
}

const Start = () => {
  const [data, setData] = useState({})
  const { addToast } = useToasts()
  const [showSummary, setShowSummary] = useState(false)
  const [loading, setLoading] = useState(false)
  const [config, setConfig] = useState({})

  // Submit Data
  const handleSubmit = (values) => {
    setShowSummary(true)

    setData({
      account_number:
        typeof window !== `undefined`
          ? localStorage.getItem("nuban_id_24b854967")
          : null,
      business_name: values.business_info.business_name,
      bn_rc_number: values.business_info.bn_rc_number,
      tin: values.business_info.tin,
      certificate_of_registration:
        values.additional_documents.certificate_of_registration,
      certificate_of_registration_name:
        values.additional_documents.certificate_of_registration_name,
      new_email: values.updates.new_email,
      new_phone: values.updates.new_phone,
      registration_date: values.business_info.registration_date,
      business_address: values.business_info.business_address,
    })
  }

  const createRecord = async (fields) => {
    console.log(fields)

    await fetch(`${process.env.DIY_BASE_URL}/api/order/v1/TinUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Token ${localStorage.getItem("dd_token")}`,
      },
      body: JSON.stringify(fields),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response)
      })
      .catch((error) => {
        console.error(error)
        return []
      })

    sendNotification({
      to: "indy@sparkle.ng",
      cc: "hello@diylaw.ng",
      from: "indy@sparkle.ng",
      subject: `New Tin Update Registration By ${fields.company_name}`,
      templateId: "d-931d7904508c488296cbcaf2cb60b93b",
      dynamicTemplateData: {
        subject: `New Tin Update Registration By ${fields.company_name}`,
        name: fields.company_name,
        email: fields.email,
        service: "New Tin Update",
      },
    })
  }

  const onSuccess = async (reference) => {
    await createRecord({
      tin_number: data.tin,
      company_name: data.business_name,
      registration_date: data.registration_date,
      rc_number: data.bn_rc_number,
      email: data.new_email,
      phone: data.new_phone,
      business_address: data.business_address,
      certificate: {
        name: data.certificate_of_registration,
      },
    })

    notifyUser({
      to: data.new_email,
      from: "indy@sparkle.ng",
      subject: `Tin Update Application`,
      templateId: "d-2cdda944684646bab40aa5e12d514a8d",
      dynamicTemplateData: {
        subject: `Tin Update Application`,
        name: data.business_name,
        service: "Tin Update",
      },
    })

    localStorage.clear()
    setLoading(false)

    addToast("Application Successful", {
      appearance: "success",
      placement: "top-center",
      autoDismiss: true,
    })

    setTimeout(function () {
      navigate("/business-support/get-started")
    }, 2000)
  }

  const initPayment = async () => {
    var min = 10000000000000
    var max = 99999999999999

    var payoutRef = Math.round(Math.random() * (max - min) + min).toString()

    let payload = {
      reference: payoutRef,
      email: data.new_email,
      amount: 500000,
      metadata: {
        additionalMessage: "Payment for TinUpdate!",
        custom_fields: [
          {
            display_name: "Business Support Service",
            variable_name: "Business Support Service",
            value: "TinUpdate",
          },
        ],
      },
      publicKey: process.env.PAYSTACK_KEY,
      paymentType: "Card",
    }

    await setConfig({ ...config, ...payload })
    document.querySelector("button.paystack").click()
  }

  const componentProps ={
    email:  data.proprietor_email,
    amount: 500000,
    metadata: {
        custom_fields: [
          {
            display_name: "Business Support Service",
            variable_name: "Business Support Service",
            value: "TinUpdate",
          },
        ],
      },
       text:"Pay with Card",
       publicKey: process.env.PAYSTACK_KEY,
       onSuccess : (reference) => onSuccess(reference),
       onClose: onClose
  }

  return (
    <div>
      <div className={!showSummary ? "container" : "container d-none"}>
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <h2 className="sparkle--title sparkle-deep-blue my-5">
              TIN Correction
            </h2>

            <div className="business-suport-card my-lg-5 waitlist__form ">
              <FormikWizard
                steps={steps}
                onSubmit={handleSubmit}
                render={FormWrapper}
              />
            </div>
          </div>
        </div>
      </div>

      <PaystackButton
        {...componentProps}
        className="btn paystack d-none"
      />

      {showSummary && (
        <Summary
          data={data}
          payFee={initPayment}
          setShowSummary={setShowSummary}
          loadingStatus={loading}
        />
      )}
    </div>
  )
}
export default Start
